import { z } from 'zod';
import { createEnumSchemaPreprocessor } from '../../../utils/create-enum-schema-preprocessor';

export const hazmatTypeOptions = [
  'None',
  'General',
  'Corrosive',
  'Explosives',
  'Flammable',
  'Inhalants',
  'Radioactive',
  'HarmfulToWater',
] as const;

export const hazmatTypeSchema = createEnumSchemaPreprocessor(
  z.enum(hazmatTypeOptions),
  hazmatTypeOptions
);

export type HazmatType = z.infer<typeof hazmatTypeSchema>;
